import { Common } from '@thecvlb/design-system/lib/src';

import { ReducedSignupStepProps } from 'containers/SignUp/Content/content.types';

const NoticeForCalifornia: React.FC<ReducedSignupStepProps> = ({ moveToStep }) => {
  return (
    <div className="flex flex-col items-center gap-6">
      <div className="rounded-full bg-yellow-100 p-3 text-yellow md:p-6">
        <Common.Icon className="size-16" name="error-outline" />
      </div>
      <div className="flex flex-col items-center gap-2 text-center text-primary-700">
        <h4 className="text-mXl font-bold md:text-2xl" data-testid="header">
          Notice for California Patients
        </h4>
        <p className="font-semibold">
          Due to state-specific regulations, compounded GLP-1 medications are currently not
          available in California. However, we are committed to ensuring you get the treatment you
          need.
        </p>
      </div>
      <div className="flex items-center gap-3 rounded-lg bg-secondary-100 p-4">
        <Common.Icon className="flex-none text-secondary" name="stethoscope" />
        <p>
          The most effective way to access GLP-1 medication will be through your insurance provider.
          While this process may seem daunting, this will be your best route to obtain your
          medication without facing high out-of-pocket costs. But don’t worry, our team is here to
          assist you every step of this process. While the insurance approval and prior
          authorization (PA) process can take up to 60 days, we’ll provide all the necessary
          documentation and support needed to streamline your approval process.
        </p>
      </div>
      <Common.Button color="blue" fullWidthOnMobile onClick={() => moveToStep('next')}>
        Continue
      </Common.Button>
    </div>
  );
};

export default NoticeForCalifornia;
